export class AdGateConstants
{
    public static readonly MODULE_DASHBOARD: number         = 1;
    public static readonly MODULE_LINEAR: number            = 2;
    public static readonly MODULE_STREAMING: number         = 3;
    public static readonly MODULE_PRODUCTION: number        = 4;

    public static readonly MODULE_ADMINPANEL: number        = 5;
    // public static readonly MODULE_USERS: number             = 5;
    // public static readonly MODULE_ROLES: number             = 6;
    // public static readonly MODULE_OFFICES: number           = 7;
    // public static readonly MODULE_AGENCIES: number          = 8;

    public static readonly UPLOADMETHOD_NOUPLOAD: number    = 0;
    public static readonly UPLOADMETHOD_HTTP: number        = 1;
    public static readonly UPLOADMETHOD_ASPERA: number      = 2;


    public static readonly ADGATE_DATE_FORMATS = {
        parse: {
            dateInput: 'D/M/YYYY',
        },
        display: {
            dateInput: 'D/M/YYYY',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM YYYY',
        },
    };


}